var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      staticClass: "strike-price-hour-header",
      attrs: {
        "data-testid":
          "strike-price-hour-header-" + _vm.params.column.getColId()
      },
      on: { click: _vm.selectColumn }
    },
    [_vm._v("\n  " + _vm._s(_vm.params.displayName) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }